<div class="lost">
  {{ message }}
</div>
